import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import trainingGuideImg from '../../images/reference-tools.svg';
import coverageGuideImg from '../../images/training-guides.svg';
import faqImg from '../../images/faq.svg';
import rightArroImg from '../../images/cheveron-right.svg';

import style from './ReferenceToolsPage.module.css';

const ReferenceToolsPage = React.memo(() => {
  useEffect(() => {
    document.title = 'HUB Portal: Reference Tools';
  }, []);

  return (
    <div className={style.tools}>
      <h1>Reference Tools</h1>
      <ul className={style.items}>
        <li className={style.item}>
          <Link to="/training-guides">
            <div className={style.itemImg}>
              <img
                className={style.toolImg}
                src={trainingGuideImg}
                alt="training guides"
              />
            </div>
            <span>Training Guides</span>
            <div className={style.arrow}>
              <img src={rightArroImg} alt="" />
            </div>
          </Link>
        </li>
        <li className={style.item}>
          <Link to="/coverage-guides">
            <div className={style.itemImg}>
              <img src={coverageGuideImg} alt="coverage guides" />
            </div>
            <span>Coverage Guide</span>
            <div className={style.arrow}>
              <img src={rightArroImg} alt="" />
            </div>
          </Link>
        </li>
        <li className={style.item}>
          <Link to="/faq">
            <div className={style.itemImg}>
              <img src={faqImg} alt="faq" />
            </div>
            <span>FAQ</span>
            <div className={style.arrow}>
              <img src={rightArroImg} alt="" />
            </div>
          </Link>
        </li>
      </ul>
    </div>
  );
});

export default ReferenceToolsPage;
